module.exports = __webpack_public_path__ + "img/Moloch-01.b32e4c12.png";